<template>
    <div>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <Loading v-bind:show="showLoadingButton">
            <md-content>
                <md-table v-model="searched" :md-sort="OrderBy" md-sort-order="desc" md-card @md-selected="onSelect" class="semMargin" items-per-page="5">
                    <md-table-toolbar>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item" v-if="showCombo1 == true">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{comboDetails1.titulo}}</label>
                                    <md-select v-model="combo1" name="combo1" id="combo1" @md-selected="changeCombo(combo1, 1)" class="filtro" style="color:#6361FB !important">
                                        <md-option :value="c.value" v-for="c in comboDetails1.dados" :key="c.value" class="option">
                                            {{c.text}}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item" v-if="showCombo2">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{comboDetails2.titulo}}</label>
                                    <md-select name="combo2" id="combo2" v-model="combo2" @md-selected="changeCombo(combo2, 2)" class="filtro">
                                        <md-option :value="c.value" v-for="c in comboDetails2.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>

                            <div class="md-layout-item" v-if="showCombo3">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{comboDetails3.titulo}}</label>
                                    <md-select name="combo3" id="combo3" v-model="combo3" @md-selected="changeCombo(combo3, 3)" class="filtro">
                                        <md-option :value="c.value" v-for="c in comboDetails3.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout-item padding-pesquisar align-right">
                            <md-field class="md-toolbar-section-end">
                                <md-input placeholder="Pesquisar..." v-model="search" @input="searchOnTable" class="filtro color6361FB webkit-text-fill-color6361FB" />
                                <button v-on:click="limparPesquisa" class="buttonLimpar">
                                    <md-icon>backspace</md-icon>
                                    <md-tooltip md-direction="top">Limpar pesquisa</md-tooltip>
                                </button>
                            </md-field>
                        </div>

                    </md-table-toolbar>

                    <md-table-empty-state md-label="Nenhum resultado encontrado"
                                          :md-description="`Nenhum registro encontrado. Tente pesquisar com outra informação.`">
                    </md-table-empty-state>



                    <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single" v-on:click="exibirDetalhes(item)">
                        <md-table-cell :md-label="c.Titulo" :md-sort-by="c.Field" :v-width="c.width" v-for="c in Header" :key="c.Field">

                            <p class="s-h4 regular" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'texto'">{{item[c.Field]}}</p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'numero'">{{item[c.Field]}}</p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'date'" v-formatdate="item[c.Field]"></p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'dataTime'" v-formatdatetime="item[c.Field]"></p>

                            <p class="s-h4 regular" style="text-align:center" v:tool :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'moeda'" v-formatmoeda="item[c.Field]"></p>

                            <div md-label="Acessar" v-if="c.Titulo != 'Ocultar' && c.Titulo =='Link'" width="30px">
                                <button v-on:click="acessarLink(item[c.Field])"><md-icon>link</md-icon></button>
                            </div>

                            <div md-label="c.Titulo" v-if="c.Tipo =='button' && item[c.Campo] == c.Condicao" width="30px">
                                <button v-on:click="buttonClick(item, c.Servico, c.Metodo)" class="button"><md-icon>description</md-icon></button>
                            </div>

                            <div v-if="c.Tipo == 'remove-button'" width="20px">
                                <button class="md-icon-button md-raised" v-on:click="alertRemoveClick(item, $event)">
                                    <md-icon>delete</md-icon>
                                </button>
                            </div>
                        </md-table-cell>

                    </md-table-row>
                </md-table>


                <div class="md-toolbar-section-start padding-20" v-if="Title">
                    <p>{{Title}} ({{searched.length}})</p>
                </div>

                <div v-if="selected" class="padding-20" style="color:#fff">
                    <p><strong>Linha selecionada:</strong></p>
                    {{ selected }}
                </div>
                <md-dialog :md-active.sync="loadDetails" class="md-layout-item md-size-50 zindex">
                    <div class="padding-20">

                        <h2 class="divLeft200">Mais informações</h2>
                        <md-dialog-actions class="divRight">
                            <md-button class="md-primary" @click="loadDetails = false">Fechar</md-button>
                        </md-dialog-actions>
                        <div style="clear:both"></div>
                        <div v-for="c in HeaderDetalhes" :key="c.Field">
                            <div v-for="a in valorDetalhes" :key="a.Titulo">
                                <div v-if="a[c.Field] != null && a[c.Field] != ''">
                                    <p v-if="c.Tipo == 'texto' || c.Tipo == 'numero'"><strong>{{c.Titulo}}: </strong> {{a[c.Field]}}</p>

                                    <p v-if="c.Tipo == 'date'"><strong>{{c.Titulo}}: </strong> <span v-formatdate="a[c.Field]"></span></p>
                                    <p v-if="c.Tipo == 'dataTime'"><strong>{{c.Titulo}}: </strong> <span v-formatdatetime="a[c.Field]"></span></p>
                                    <p v-if="c.Tipo == 'moeda'"><strong>{{c.Titulo}}: </strong> <span v-formatmoeda="a[c.Field]"></span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </md-dialog>
                <md-dialog-confirm :md-active.sync="removeClick"
                                   md-title="Remover Situação Acadêmica"
                                   :md-content="contentHtml"
                                   md-confirm-text="Confirmar"
                                   md-cancel-text="Cancelar"
                                   @md-cancel="onCancelRemove"
                                   @md-confirm="removeClickConfirm" />
            </md-content>
        </Loading>
    </div>

</template>

<script>

    import { formatdatetime } from '@/directives/formatdatetime.js';
    import { formatdate } from '@/directives/formatdate.js';
    import { formatmoeda } from '@/directives/formatmoeda.js';
    import Button from '@/services/ButtonService.js';
    import Loading from '@/components/Loading';
    import SituacaoAcademica from '@/services/SituacaoAcademicaService.js';

    export default {

        name: 'GridSituacaoAcademica',
        components: {
            Loading
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                }
                else
                    this.$router.push('home');
            }

            this.buttonService = new Button(this);

            this.situacaoAcademicaService = new SituacaoAcademica(this);

            this.searched = this.dados;
            if (this.comboDetails1 != null &&
                this.comboDetails1.titulo != undefined) {
                this.combo1 = this.comboDetails1.dados[0].value;
                this.showCombo1 = true;
            }

            if (this.comboDetails2 != null &&
                this.comboDetails2.titulo != undefined) {
                this.combo2 = this.comboDetails2.dados[0].value;
                this.showCombo2 = true;
            }

            if (this.comboDetails3 != null &&
                this.comboDetails3.titulo != undefined) {
                this.combo3 = this.comboDetails3.dados[0].value;
                this.showCombo3 = true;
            }
        },
        directives: {
            formatdatetime,
            formatdate,
            formatmoeda
        },
        props: {
            Data: {
                type: Array
            },
            Header: {
                type: Array
            },
            Name: String,
            Title: String,
            OrderBy: String,
            HeaderDetalhes: {
                type: Array
            },
            DetalhesCombo1: {
                type: Object
            },
            DetalhesCombo2: {
                type: Object
            },
            DetalhesCombo3: {
                type: Object
            }
        },
        data:
            function () {
                return {
                    selected: null,
                    aluno: null,
                    dados: this.Data,
                    dadosSituacaoAcademica: null,
                    headers: this.Header,
                    search: '',
                    headerDetalhes: this.HeaderDetalhes,
                    loadDetails: false,
                    removeClick: false,
                    comboDetails1: this.DetalhesCombo1,
                    comboDetails2: this.DetalhesCombo2,
                    comboDetails3: this.DetalhesCombo3,
                    showCombo1: false,
                    showCombo2: false,
                    showCombo3: false,
                    valorDetalhes: [],
                    itemRemoveDetails: [],
                    valorPesquisaCombo: [],
                    combo1: '',
                    combo2: '',
                    combo3: '',
                    showLoadingButton: false,
                    contentHtml: `<i class="fa fa-exclamation-triangle" style="margin-right: 8px; color: orange;"></i>
                                  Você confirma a <strong>exclusão</strong> dessa Situação Acadêmica?`
                }
            },

        methods: {
            buttonClick(parametros, servico, metodo) {

                this.showLoadingButton = true;
                this.buttonService.Acao({
                    Parametros: parametros,
                    Servico: servico,
                    Metodo: metodo,
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoTurma: this.aluno.codigoTurma,
                    CodigoEmpresa: this.aluno.codigoEmpresa
                }).then(
                    data => {
                        if (!data.ok) {
                            this.$modal.alert(data.mensagem);
                        }
                    },
                    error => {
                        this.$modal.error('Ocorreu um erro ao executar a ação.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                    }).finally(() => {
                        this.showLoadingButton = false;
                    });
            },

            getClass: () => ({
                'md-primary': 2
            }),
            onSelect(item) {
                this.selected = item;
            },
            limparPesquisa() {
                this.valorPesquisaCombo = [];
                this.combo1 = '';
                this.combo2 = '';
                this.combo3 = '';
                this.searched = this.dados;
                this.search = "";
            },

            changeCombo(valor, combo) {

                if (valor == "Todos") {
                   
                    var comboValue1 = this.combo1;
                    var comboValue2 = this.combo2;
                    var comboValue3 = this.combo3;

                    this.limparPesquisa();
                    switch (combo) {
                        case 1:
                            if (comboValue2 && comboValue2 != "Todos") {
                                this.valorPesquisadoCarregar(2, comboValue2);
                                this.combo2 = comboValue2;
                            }
                                
                            if (comboValue3 && comboValue3 != "Todos") {
                                this.valorPesquisadoCarregar(3, comboValue3);
                                this.combo3 = comboValue3;
                            }
                            break;

                        case 2:
                            if (comboValue1 && comboValue1 != "Todos") {
                                this.valorPesquisadoCarregar(1, comboValue1);
                                this.combo1 = comboValue1;
                            }

                            if (comboValue3 && comboValue3 != "Todos"){
                                this.valorPesquisadoCarregar(3, comboValue3);
                                this.combo3 = comboValue3;
                            }
                            break;

                        case 3:
                            if (comboValue1 && comboValue1 != "Todos"){
                                this.valorPesquisadoCarregar(1, comboValue1);
                                this.combo1 = comboValue1;
                            }

                            if (comboValue2 && comboValue2 != "Todos"){
                                this.valorPesquisadoCarregar(2, comboValue2);
                                this.combo2 = comboValue2;
                            }
                            break;
                    }
                }
                else
                    this.valorPesquisadoCarregar(combo, valor);

                this.searchOnTable();
            },

            valorPesquisadoCarregar(combo, valor) {
                if (this.valorPesquisaCombo.find(element => element.Combo == combo))
                    this.valorPesquisaCombo.find(element => element.Combo == combo).Valor = valor.toString();
                else
                    this.valorPesquisaCombo.push({ Combo: combo, Valor: valor.toString() });
            },

            exibirDetalhes(valor) {
                this.valorDetalhes = [];
                if (this.headerDetalhes != null) {
                    this.valorDetalhes.push(valor);
                    this.loadDetails = !this.loadDetails;
                }
            },

            acessarLink(valor) {
                window.open(valor);
            },
            searchOnTable() {

                this.searched = [];
                this.searched = this.dados;
                let oldValue = ''
                if (this.search) {
                    oldValue = this.search;
                    this.searched = this.dados.filter(containsText(this.search, this.headers));
                }

                if (this.valorPesquisaCombo.length > 0) {
                    for (var i = 0; i < this.valorPesquisaCombo.length; i++) {
                        this.search = this.valorPesquisaCombo[i].Valor;
                        this.searched = this.searched.filter(containsText(this.search, this.headers));
                    }

                    this.search = oldValue;
                }
            },

            alertRemoveClick(item, event) {
                this.itemRemoveDetails = [];
                if (item != null) {
                    this.itemRemoveDetails.push(item);
                }
                event.stopPropagation();
                this.removeClick = true;
            },

            onCancelRemove() {
                this.removeClick = false;
            },

            removeClickConfirm() {
                this.$emit('changeShowButtonInclude', false);
                this.showLoadingButton = true;
                
                this.situacaoAcademicaService.ExcluirSituacaoAcademica({
                    codigoAluno: this.aluno.codigoAluno,
                    codigoEspecialidade: this.aluno.codigoEspecialidade,
                    codigoPeriodo: this.itemRemoveDetails[0].periodo,
                    dataSituacao: this.itemRemoveDetails[0].dataSituacao,
                    codigoSituacao: this.itemRemoveDetails[0].situacao,
                    textoSituacao: this.itemRemoveDetails[0].observacao
                }).then(
                    data => {
                        if (data.ok) {
                            this.$modal.info('Situação Acadêmica <strong>'
                                + this.itemRemoveDetails[0].situacaoDescricao
                                + '/'
                                + this.itemRemoveDetails[0].periodo
                                + '</strong> removida com sucesso!');
                            this.$emit('changeShowButtonInclude', true);
                            this.$emit('carregaAba');
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }
                ).finally(() => {
                    this.showLoadingButton = false;
                });

                this.removeClick = true;
            }
        }
    }

    function containsText(search, headers) {
        return function (element) {

            for (var i = 0; i < headers.length; i++) {
                if (element[headers[i].Field]
                    && element[headers[i].Field].toString().toLowerCase().includes(search.toLowerCase()))
                    return true;
            }
            return false;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .grid {
        width: 30em;
        overflow-x: auto;
        white-space: pre-wrap;
    }

    .theme-default {
        background-color: #9b9b9b;
        color: white;
    }

    .theme-primary {
        background-color: #448aff;
        color: white;
    }

    .theme-success {
        background-color: #009688;
        color: white;
    }

    .theme-danger {
        background-color: #ff5252;
        color: white;
    }

    .theme-warning {
        background-color: #f9aa33;
        color: white;
    }

    .align-right {
        float: right;
        padding: 20px;
    }

    .padding-20 {
        padding: 0 0 10px 20px;
    }

    .padding-pesquisar {
        padding: 0 0 0 30px;
    }


    .md-table-cell-container {
        padding: 0px;
    }

    .zindex {
        z-index: 1000;
    }

    .buttonLimpar {
        background-color: transparent;
        border: 0;
    }

    .filtro {
        height: 40px !important;
        font-size: 20px !important;
    }

    .color6361FB {
        color: #6361FB !important;
    }

    .option {
        background-color: #fff !important;
    }

        .option:hover {
            background-color: #6361FB !important;
        }

    .webkit-text-fill-color6361FB {
        -webkit-text-fill-color: #6361FB !important;
    }

    .border6361FB {
        border-bottom-color: #6361FB !important;
    }

    .semMargin {
        padding: 0 !important;
        margin: 0 !important;
    }

    .button {
        background-color: transparent;
        border: 0px;
    }

    .divLeft200 {
        width: 200px;
        float: left;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }

    .divRight {
        width: 100px;
        float: right;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }

    .md-icon-button:hover {
        background-color: darkgrey;
    }

    .fa-exclamation-triangle {
        margin-right: 10px;
        color: orange !important;
        width: 3em;
    }
</style>
